export default [
  {
    path: "/yx3605",
    name: "yx3605",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/sougou3",
    name: "sougou3",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/sougou2",
    name: "sougou2",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/ibaidu2",
    name: "ibaidu2",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/ibaidu",
    name: "ibaidu",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/msougou2",
    name: "msougou2",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc4",
    name: "uc4",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc3",
    name: "uc3",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc2",
    name: "uc2",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc",
    name: "uc",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zdzm",
    name: "zdzm",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/wm",
    name: "wm",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/msougou1",
    name: "msougou1",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/m996",
    name: "m996",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/msougou",
    name: "msougou",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/360m/001",
    name: "360m/001",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/kuaishou",
    name: "kuaishou",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/wangyiyixiao",
    name: "wangyiyixiao",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/dxaiqiyi",
    name: "dxaiqiyi",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/jyaiqiyi",
    name: "jyaiqiyi",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/jiayinwangyiyunyinyue",
    name: "jiayinwangyiyunyinyue",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/jiayinwangyixinwen",
    name: "jiayinwangyixinwen",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/360m",
    name: "360m",
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/sigmob1",
    name: "sigmob1",
    component: () => import("@/views/baseMb/index.vue"),
  }
];
